module.exports = __webpack_public_path__ + "img/rightbicep-ecto-mesomorph-female.7acbb9d2.svg";